import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { ProductCoverMaterialTileModel } from '@/types/B2CcontentServerContract';
import BaseLayout2575and7525, { TileContent } from '@/shared/content/blocks/call-to-action-layouts/shared/BaseLayout2575and7525.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCoverMaterialTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: ProductCoverMaterialTileModel }



const textTileContentBlock = computed<TileContent>(() => {
    const { title, text, link, linkTitle } = props.content;
    return {
        title,
        text,
        link: {
            url: link.url,
            spaLink: link.spaLink,
            text: linkTitle,
        },
    };
});

const mediaTileContentBlock = computed<TileContent>(() => {
    return {
        media: props.content.media,
        zoom: false,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLayout2575and7525, {
    "text-tile-content-block": _unref(textTileContentBlock),
    "media-tile-content-block": _unref(mediaTileContentBlock),
    "alternative-link-style": true
  }, null, 8, ["text-tile-content-block", "media-tile-content-block"]))
}
}

})